import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-terms-of-use-cz',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './terms-of-use-cz.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
})
export class TermsOfUseCzComponent {
  @Input() effectiveDate!: string;
  @Input() version!: string;
  @Input() supportEmail!: string;
  @Input() websiteUrl!: string;
  @Input() termsUrl!: string;
  @Input() rssFeedUrl!: string;
}
